import SyncRule from './src/sync-rule';

export default SyncRule;
